import React from 'react';

import RegistrationForm from '../../presentational/RegistrationForm';

class Register extends React.Component {
    render() {
        return (
            <div>
                 <RegistrationForm />
            </div>
        )
    }
}

export default Register

